import DataSource from "../DataSource";
import Resource from "../Resource";

export default class PrevadzkovaKnihaService {

  constructor(server, AuthService){
    this.server = server;
    this.AuthService = AuthService;
  }

  getListSource(config = {}){
    return new DataSource(this.server, "PrevadzkovaKniha.list", config);
  }

  getResource(){
    return new Resource(this.server, "PrevadzkovaKniha");
  }

  getRecord(id){
    if(id == 0){
      return this.getResource().getRecord({
        zakaznik: null,
        acl: [],
        ustredne: [],
        hlasice: [],
        signalizacnePrvky: [],
        ineZariadenia: [],
      });
    }
    return this.getResource().read(id);
  }

  getLogSource(knihaId){
    return new DataSource(this.server, "PrevadzkovaKnihaZaznam.list", {filter: {knihaId: knihaId}})
  }

  cancelLog(logId){
    return this.server("PrevadzkovaKnihaZaznam.cancel",{id: logId});
  }

  getLogOptions(acl){
    var canWriteAll = this.AuthService.can("PREVADZKOVA_KNIHA_ADMIN");

    return [
      {label: "Denná kontrola", value: 0},
      {label: "Mesačná kontrola", value: 1},
      {label: "Štvrťročná kontrola", value: 2},
      {label: "Ročná kontrola", value: 3},
      {label: "Záznam", value: 4},
    ].filter(o => canWriteAll || acl.filter(acl => acl.uzivatel.id == this.AuthService.user.id).map(i => i.typyZaznamu.indexOf(o.value) >=0?1:0).reduce((a,b) => a+b, 0) > 0)
  }
  
}


// WEBPACK FOOTER //
// ./src/prevadzkova-kniha/PrevadzkovaKnihaService.js